import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { InfiniteScrollCustomEvent, ModalController, NavController, NavParams, Platform } from '@ionic/angular';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { SocketsService } from 'src/app/_provider/sockets.service';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';
import { ZeitenService } from 'src/app/_provider/zeiten.service';

@Component({
  selector: 'app-ticket-detail-page',
  templateUrl: './ticket-detail-page.page.html',
  styleUrls: ['./ticket-detail-page.page.scss'],
})
export class TicketDetailPagePage implements OnInit, OnDestroy {

  //Können bei aufruf von Model übergeben werden...
  public isModal: boolean
  public modelWorkstepId: number = 0
  public highlightedContentId: number = 0

  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    public ticketSrv: TicketEmployee.TicketService,
    public timeSrv: ZeitenService,
    public platform: Platform,
    private feedback: FeedbackService,
    public generalSrv: GeneralService,
    private socketSrv: SocketsService
  ) {}

  ngOnInit() {
    if(this.isModal) this.ticketSrv.isOnModelDisplayed = true
  }

  public async closePage(){
    await this.feedback.hideKeyboardOnIOS()
    if(this.isModal) await this.modalCtrl.dismiss()
    else this.navCtrl.pop()
  }

  ngOnDestroy(){
    this.ticketSrv.isOnModelDisplayed = false
    if(this.ticketSrv.lastTicketId){
      this.socketSrv.leaveGroup(`ticket_${this.ticketSrv.lastTicketId}`)
      this.socketSrv.removeHandler("UserDisconnected")
      this.ticketSrv.socketUser = []
    }
  }

  public async doRefresh(event: any){
    this.generalSrv.setActiveTicket(this.ticketSrv.ticket)
    await this.timeSrv.getAllActiveTimes()
    this.modelWorkstepId = this.ticketSrv.activeWorkstepId
    setTimeout(() => {
      event.target.complete()
    }, 300);
  }

  public async openInNewTab(){
    this.ticketSrv.openInNewTab()
  }

}
